import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/video-3-violet.webm";
import avatarVideoMp4 from "../../assets/avatares/video-3-violet.mp4";
import manuelVideo from "../../assets/avatares/juan-consulta.webm";
import manuelVideoMp4 from "../../assets/avatares/juan-consulta.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario3Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Entonces… ¿qué opciones tengo ahora?<br/>Después de todo lo que ya he pasado, imagino que no todas las opciones son iguales… ni todas estarán disponibles para mí.<br/>Yo solo sé que quiero un tratamiento que me dé tiempo, pero también que me permita seguir con mi vida, trabajar… sentirme útil.<br/>No sé cuál es el mejor camino, pero necesito que encaje conmigo, no solo con la enfermedad."

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "violet", true);
	};

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO3);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 35000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "50%",
								marginTop: "24px",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur-violet h-100 px-5">
						<div className="recuadro-white txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos txt-red mb-4">
								Avanzamos al siguiente movimiento
							</h3>
							<p>Han confirmado la progresión de Juan. Al ser un paciente triple expuesto, el rescate exige avanzar hacia las terapias</p>
							<p>El arsenal es amplio e incluye opciones como células CAR-T y anticuerpos biespecíficos</p>
							<p>Para encontrar la partitura perfecta, la eficacia teórica no bastará. Deberán sortear dos grandes obstáculos:</p>
							<p>La barrera del acceso: ¿Qué terapias están verdaderamente disponibles en su país hoy?</p>
							<p>La vida real del paciente: ¿Qué diana farmacológica protegerá mejor las herramientas de trabajo y el futuro de Juan?</p>
        					<div className="notaCasoClinicoAutor">caso clínico del autor</div>
						</div>
						<div className="d-flex justify-content-center">
							<div
								className={`button-escuchar-paciente button-escuchar-paciente-violet mt-4 mb-4 ${!canOpenDialog ? "is-disabled" : ""}`}
								aria-disabled={!canOpenDialog}
								onClick={canOpenDialog ? abrirModal : undefined}
								style={!canOpenDialog ? { pointerEvents: "none" } : undefined}
							>
								Escuchar al paciente
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario3Intro);
